import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, AfterViewInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { v_QuoteEquipmentBus } from '@app/cp/shared/models/v_QuoteEquipmentBus';
import { InvoiceLineItemsSummary } from '@app/cp/shared/models/InvoiceLineItemsSummary';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { QuoteService } from '@app/cp/shared/services/quote.service';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

const matches = (el, selector) => (el.matches || el.msMatchesSelector).call(el, selector);

@Component({
    selector: 'quote-equipment',
    templateUrl: './quote-equipment.component.html',
    styleUrls: ['./quote-equipment.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class QuoteEquipmentComponent extends BaseGridEditLineComponent<v_QuoteEquipmentBus, null, QuoteService> { // CPWorkOrderDetailComponent>  {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: QuoteService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.disableCpSearchDialog();
        this.className = "v_QuoteEquipmentBus";
        this.appCode = "QuoteEquipment";
        this.disableCpSearchDialog();
    }

    createForm() {
        this.editForm = new UntypedFormGroup({
            'quoteId': new UntypedFormControl(),
            'equipmentId': new UntypedFormControl(),
            'manufacturerId': new UntypedFormControl(),
            'manufacturerTypeId': new UntypedFormControl(),
            'quoteEquipmentXREFId': new UntypedFormControl(),
            'systemId': new UntypedFormControl(),
            'model': new UntypedFormControl(),
            'serialNumber': new UntypedFormControl(),
            'barcode': new UntypedFormControl(),
            'notes': new UntypedFormControl(),
            'creationDate': new UntypedFormControl(),
             'isPrintable': new UntypedFormControl()
        });

    }
    setForm() {
        this.editForm.patchValue({
            quoteId: this.selectedData.quoteId,
            equipmentId: this.selectedData.equipmentId,
            manufacturerId: this.selectedData.manufacturerId,
            manufacturerTypeId: this.selectedData.manufacturerTypeId,
            quoteEquipmentXREFId: this.selectedData.quoteEquipmentXREFId,
            systemId: this.selectedData.systemId,
            model: this.selectedData.model,
            serialNumber: this.selectedData.serialNumber,
            barcode: this.selectedData.barcode,
            notes: this.selectedData.notes,
            creationDate: this.selectedData.creationDate,
            isPrintable: this.selectedData.isPrintable
        });
    }
    setFromReferenceData(data: v_QuoteEquipmentBus) {
        data.manufacturerName = this.referenceData.getManufacturerDesc(data.manufacturerId);
        data.manufacturerTypeName = this.referenceData.getManufacturerTypeDesc(data.manufacturerTypeId);
        return data;
    }
    protected getChangedObject(data: v_QuoteEquipmentBus) {
        let busObj: v_QuoteEquipmentBus = new v_QuoteEquipmentBus(data);
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setParentId(this._parentId);
        busObj.setBeforeSave();
        return busObj;
    }

    protected save(data: v_QuoteEquipmentBus) {
        let busObj: v_QuoteEquipmentBus = this.getChangedObject(data); // new v_QuoteEquipmentBus(data);
        //busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        //busObj.setParentId(this._parentId);
            this.svc_data.saveQuoteEquipment(busObj).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let dataObj: v_QuoteEquipmentBus = new v_QuoteEquipmentBus(info.primaryReturn);
                    this.saveSuccess(dataObj);
                }
                else {
                    this.saveError(data, CommonValues.Message_ErrorSaving);
                }
            });
    }
    deleteIndividual(data: v_QuoteEquipmentBus) {
        if (data.hasId) {
            this.svc_data.deleteQuoteEquipment(data.equipmentId).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, info.message);
                }
            });
        }
        else {
            this.closeEditor();
        }
    }

    manufacturer(id: string) {
        return this.referenceData.manufacturers.find(x => x.value === id);
    }
    manufacturerType(id: string) {
        return this.referenceData.manufacturerTypes.find(x => x.value === id);
    }
    customCheckBoxChanged(e: any, dataItem, rowIndex, column, columnIndex) {
        if (column.field === "isPrintable") {
            this.editForm.patchValue({
                isPrintable: e.target.checked
            });

        }

    }
}
